module.exports = __webpack_public_path__ + "static/img/menage1.8011cc28.jpg";